



var instances = {};

function initialiseAll() {
    let elements = $('[' + expressSelectors()['table-of-contents']['initialise'] + ']');
    if (elements.length > 0) {
        elements.each(function() {
            // Get context.
            let context = $(this);
            // Initialise all.
            let init = initialise(context);
        });
    }
}

function initialise(context) {
    let id = context.attr('table-of-contents-id');
    // If no Id then generate one.
    if (!id) {
        context.attr('table-of-contents-id', generateId());
        id = context.attr('table-of-contents-id');
        instances[id] = {};
    } else {
        if (AXISDebug.level() >= 3) {
            AXISDebug.output(1,"Sticky: Instance already initialised skipping.");
        }
        return false;
    }

    let sections = [];

    // Find all section and add to sections array.
    context.find('a').each(function(key, value) {
        // Get section id.
        let sectionId = $(value).attr('href');
        if (sectionId.length > 0) {
            // Create jQuery obj with id.
            let section = $(sectionId);
            // Add to sections array.
            sections.push(section);
        }
    });

    // Add listeners.
    // If you click in the navigation.
    context.find('a').on('click', function(event) {
        // Prevent default behavour.
        event.preventDefault();
        // Get context.
        let button = $(this);
        // Get section id.
        let sectionId = button.attr('href');
        // Section context.
        let section = $(sectionId);
        // If you cannot find section then exit.
        if (section.length == 0) {
            AXISDebug.output(3,"Table Of Contents: Could not find section", section);
            return false;
        }
        // Scroll to section.
        Foundation.SmoothScroll.scrollToLoc(section, {threshold: 150,offset: getHeaderSize(), animationDuration: 1000});
    });

    let urlUpdateTimeout = null;

    // Scroll listener which updates your position in the navigation.
    $(window).on('scroll', function() {
        let activeSection = setActiveSection();

        // To prevent the url from being spammed with updates we wait till the document has finished scrolling.
        if (urlUpdateTimeout) clearTimeout(urlUpdateTimeout);

        urlUpdateTimeout = setTimeout(() => {
            // Get section id.
            let sectionId = activeSection.find('a').attr('href');
            // Update url + history obj.
            let url = updateUrl.set(location.protocol + '//' + location.host + location.pathname + sectionId, true);
        }, 50);
    });

    // Set active state in table of contents.
    setActiveSection();

    function setActiveSection() {
        let distances = [];
        // Loop through each section finding the closest item to top.
        $.each(sections, function() {
            distances.push($(this)[0].getBoundingClientRect().bottom);
        });
        // Get the index of the closest section.
        let closestSection = getClosestIndexValue(distances, 0);

        // Get the previous section.
        let previous = closestSection - 1;
        // If we're at the begining then set previous to 0.
        if (previous < 0) {
            previous = 0;
        }

        let activeSection;
        // TODO: need to work out looking for .sg-section-container as that is too specific.
        // TODO: 300 is too specific you should really take the viewport height and / 2.
        if (sections[previous].parents('.sg-section-container')[0].getBoundingClientRect().bottom >= 300) {
            // Remove an other active instance.
            context.find('li').removeClass('active');
            // Add Find active item.
            activeSection = context.find('li:eq(' + previous + ')');
            // Add active class.
            activeSection.addClass('active');
        } else {
            // Remove an other active instance.
            context.find('li').removeClass('active');
            // Find active item.
            activeSection = context.find('li:eq(' + closestSection + ')');
            // Add active class.
            activeSection.addClass('active');
        }

        return activeSection;
    }

}








var AXISTableOfContents = $.AXISTableOfContents = {
    initialiseAll: () => {
        return initialiseAll();
    }
}
 
export { AXISTableOfContents };
